export enum CompanyPriceChangeDtoProp {
  Value = 'value',
  Growth = 'growth',
  GrowthPercent = 'growthPercent',
  Currency = 'currency',
}
